export const SCROLL_TO_TOP_BUTTON_LIMIT = 600;
export const CONST_2 = 'example';
export const PRODUCT_GROUP_ICONS = {
  1: {
    icon: 'mdi-cellphone-android',
  },
  2: {
    icon: 'mdi-tablet',
  },
  3: {
    icon: 'mdi-devices',
  },
  4: {
    icon: 'mdi-basket-fill',
  },
  5: {
    icon: 'mdi-watch-variant',
  },
  7: {
    icon: 'mdi-laptop',
  },
  8: {
    icon: 'mdi-camera-gopro',
  },
  10: {
    icon: 'mdi-router-wireless',
  },
  15: {
    icon: 'mdi-desktop-tower-monitor',
  },
  18: {
    icon: 'mdi-devices',
  },
  21: {
    icon: 'mdi-camera',
  },
  22: {
    icon: 'mdi-monitor',
  },
};
export const CAPTCHASEC = '6Ld7NeIUAAAAAJckkYl9hcj6edVtsTQ_VCZrNurx';
